<template>
  <div v-if="discipline.key === 'experiential'" class="disciplines-container panel-brands-container">
    <div class="disciplines-section">
      <section class="main-home__slide disciplines__slide slide-4 slide-4-desktop">
        <div class="embla__slide">
          <div class="panel panel-brands">
            <div class="marquee-layer" aria-hidden="true">
              <img :src="require('@/assets/images/experiential_text_red.png')" alt="" loading="lazy" />
            </div>
            <div class="panel__container">
              <div class="panel-brands__text-container">
                <div class="panel-brands__brand-uppercase">
                  <component :is="headingTag" class="discipline-heading">
                    <router-link v-if="linked" :to="discipline.path" :aria-label="`${discipline.name} at Ignis`">
                      <img :src="require('@/assets/images/experiential_text_red.png')" :alt="discipline.name" loading="lazy" />
                    </router-link>
                    <template v-else>
                      <img :src="require('@/assets/images/experiential_text_red.png')" :alt="discipline.name" loading="lazy" />
                    </template>
                  </component>
                </div>
                <div class="panel-brands__brand-title" :class="{ 'discipline-title--passthrough': linked }">
                  <img :src="require('@/assets/images/experiential_script.png')" alt="" loading="lazy" />
                </div>
              </div>
              <div class="panel-brands__brand-thumbs">
                <router-link to="/our-work/pepsi-max" class="discipline-link" data-case-study="pepsi-max"
                  data-discipline="experiential" data-track-location="home-discipline" aria-label="View the Pepsi Max case study">
                  <video class="lazy-video" disablePictureInPicture :poster="require('@/assets/images/experiential_1.png')" muted loop
                    preload="none" playsinline
                    data-src="https://ignisshowreel.s3.eu-west-1.amazonaws.com/pepsi_ww_tile_video.mp4" type="video/mp4">
                  </video>
                </router-link>
                  <img :src="require('@/assets/images/experiential_7.png')" class="Tempus One"
                    alt="Tempus One" loading="lazy" />
                <router-link to="/our-work/marriott" class="discipline-link" data-case-study="marriott"
                  data-discipline="experiential" data-track-location="home-discipline" aria-label="View the Marriott case study">
                  <video class="lazy-video" disablePictureInPicture :poster="require('@/assets/images/experiential_3.png')" muted loop
                    preload="none" playsinline
                    data-src="https://ignisshowreel.s3.eu-west-1.amazonaws.com/marriott_tile_video.mp4" type="video/mp4">
                  </video>
                </router-link>
                <div class="parallax-container">
                  <img :src="require('@/assets/images/experiential_2.png')" class="Jamesons Experience" loading="lazy" />
                </div>
              </div>
              <p class="discipline-copy">{{ discipline.copy }}</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>

  <div v-else-if="discipline.key === 'shopper'" class="disciplines-container panel-shopper-container">
    <div class="disciplines-section">
      <section class="main-home__slide disciplines__slide slide-4 slide-4-desktop">
        <div class="embla__slide">
          <div class="panel panel-shopper">
            <div class="panel-depth-bg" aria-hidden="true">
              <img :src="require('@/assets/images/shopper_text_black.png')" alt="" loading="lazy" />
            </div>
            <div class="marquee-layer marquee-layer--png" aria-hidden="true">
              <img :src="require('@/assets/images/shopper_text_black.png')" alt="" loading="lazy" />
            </div>
            <div class="marquee-layer marquee-layer--html" aria-hidden="true">
              <span class="marquee-text">SHOPPER</span>
              <span class="marquee-text">SHOPPER</span>
              <span class="marquee-text">SHOPPER</span>
            </div>
            <div class="panel__container">
              <div class="panel-shopper__text-container">
                <div class="panel-shopper__shopper-uppercase">
                  <component :is="headingTag" class="discipline-heading">
                    <router-link v-if="linked" :to="discipline.path" :aria-label="`${discipline.name} at Ignis`">
                      <img :src="require('@/assets/images/shopper_text_black.png')" :alt="discipline.name" loading="lazy" />
                    </router-link>
                    <template v-else>
                      <img :src="require('@/assets/images/shopper_text_black.png')" :alt="discipline.name" loading="lazy" />
                    </template>
                  </component>
                </div>
                <div class="panel-shopper__shopper-title" :class="{ 'discipline-title--passthrough': linked }">
                  <img :src="require('@/assets/images/shopper_script.png')" alt="" loading="lazy" />
                </div>
              </div>
              <div class="panel-shopper__shopper-thumbs">
                <router-link to="/our-work/britvic-mixers" class="discipline-link" data-case-study="britvic-mixers"
                  data-discipline="shopper-marketing" data-track-location="home-discipline" aria-label="View the Britvic Mixers case study">
                  <video class="lazy-video" disablePictureInPicture :poster="require('@/assets/images/shopper_1.png')" muted loop
                    preload="none" playsinline :data-src="videos[0]" type="video/mp4">
                  </video>
                </router-link>
                <video class="lazy-video" disablePictureInPicture :poster="require('@/assets/images/shopper_1.png')" muted loop
                  preload="none" playsinline :data-src="videos[1]" type="video/mp4">
                </video>
                <router-link to="/our-work/pepsi-max" class="discipline-link" data-case-study="pepsi-max"
                  data-discipline="shopper-marketing" data-track-location="home-discipline" aria-label="View the Pepsi Max case study">
                  <video class="lazy-video" disablePictureInPicture :poster="require('@/assets/images/shopper_1.png')" muted loop
                    preload="none" playsinline :data-src="videos[2]" type="video/mp4">
                  </video>
                </router-link>
              </div>
              <p class="discipline-copy">{{ discipline.copy }}</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>

  <div v-else-if="discipline.key === 'social'" class="disciplines-container panel-social-container">
    <div class="disciplines-section">
      <section class="main-home__slide disciplines">
        <div class="disciplines__slide slide-4 slide-4-desktop">
          <div class="embla__slide">
            <div class="panel panel-social">
              <div class="marquee-layer" aria-hidden="true">
                <img :src="require('@/assets/images/social_text_red.png')" alt="" loading="lazy" />
              </div>
              <div class="panel__container">
                <div class="panel-social__text-container">
                  <div class="panel-social__social-uppercase">
                    <component :is="headingTag" class="discipline-heading">
                      <router-link v-if="linked" :to="discipline.path" :aria-label="`${discipline.name} at Ignis`">
                        <img :src="require('@/assets/images/social_text_red.png')" :alt="discipline.name" loading="lazy" />
                      </router-link>
                      <template v-else>
                        <img :src="require('@/assets/images/social_text_red.png')" :alt="discipline.name" loading="lazy" />
                      </template>
                    </component>
                  </div>
                  <div class="panel-social__social-title" :class="{ 'discipline-title--passthrough': linked }">
                    <img :src="require('@/assets/images/digital_script.png')" alt="" loading="lazy" />
                  </div>
                </div>
                <div class="panel-social__social-thumbs">
                  <router-link to="/our-work/marriott" class="discipline-link" data-case-study="marriott"
                    data-discipline="social-digital" data-track-location="home-discipline" aria-label="View the Marriott case study">
                    <video class="lazy-video" disablePictureInPicture :poster="require('@/assets/images/social_thumb_1.png')" muted
                      loop preload="none" playsinline
                      data-src="https://ignisshowreel.s3.eu-west-1.amazonaws.com/NFL_v1a.mp4" type="video/mp4">
                    </video>
                  </router-link>
                  <router-link to="/our-work/asahi" class="discipline-link" data-case-study="asahi"
                    data-discipline="social-digital" data-track-location="home-discipline" aria-label="View the Asahi case study">
                    <div class="parallax-container">
                      <img :src="require('@/assets/images/social_thumb_5.png')" class="social-thumb-1"
                        alt="Asahi Super Dry on a phone" loading="lazy" />
                    </div>
                  </router-link>

                  <router-link to="/our-work/campari" class="discipline-link" data-case-study="campari"
                    data-discipline="social-digital" data-track-location="home-discipline" aria-label="View the Campari case study">
                    <video class="lazy-video" disablePictureInPicture :poster="require('@/assets/images/social_thumb_3.png')" muted
                      loop preload="none" playsinline
                      data-src="https://ignisshowreel.s3.eu-west-1.amazonaws.com/Campari2_v1a.mp4" type="video/mp4">
                    </video>
                  </router-link>
                  <router-link to="/our-work/asahi" class="discipline-link" data-case-study="asahi"
                    data-discipline="social-digital" data-track-location="home-discipline" aria-label="View the Asahi case study">
                    <div class="parallax-container">
                      <img :src="require('@/assets/images/social_thumb_4.png')" class="social-thumb-3"
                        alt="Asahi App" loading="lazy" />
                    </div>
                  </router-link>
                </div>
                <p class="discipline-copy">{{ discipline.copy }}</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>

  <div v-else-if="discipline.key === 'comms'" class="disciplines-container panel-comms-container">
    <div class="disciplines-section">
      <section class="main-home__slide disciplines">
        <div class="disciplines__slide slide-4 slide-4-desktop">
          <div class="embla__slide">
            <div class="panel panel-comms">
              <div class="panel-depth-bg" aria-hidden="true">
                <img :src="require('@/assets/images/comms_text_black.png')" alt="" loading="lazy" />
              </div>
              <div class="marquee-layer marquee-layer--png" aria-hidden="true">
                <img :src="require('@/assets/images/comms_text_black.png')" alt="" loading="lazy" />
              </div>
              <div class="marquee-layer marquee-layer--html" aria-hidden="true">
                <span class="marquee-text">COMMUNICATIONS</span>
                <span class="marquee-text">COMMUNICATIONS</span>
                <span class="marquee-text">COMMUNICATIONS</span>
              </div>
              <div class="panel-comms__white-overlay" aria-hidden="true"></div>
              <div class="panel__container">
                <div class="panel-comms__text-container">
                  <div class="panel-comms__comms-uppercase">
                    <component :is="headingTag" class="discipline-heading">
                      <router-link v-if="linked" :to="discipline.path" :aria-label="`${discipline.name} at Ignis`">
                        <img :src="require('@/assets/images/comms_text_black.png')" :alt="discipline.name" loading="lazy" />
                      </router-link>
                      <template v-else>
                        <img :src="require('@/assets/images/comms_text_black.png')" :alt="discipline.name" loading="lazy" />
                      </template>
                    </component>
                  </div>
                  <div class="panel-comms__comms-title" :class="{ 'discipline-title--passthrough': linked }">
                    <img :src="require('@/assets/images/comms_script.png')" alt="" loading="lazy" />
                  </div>
                </div>
                <div class="panel-comms__comms-thumbs">
                  <router-link to="/our-work/jti-human-rights" class="discipline-link" data-case-study="jti-human-rights"
                    data-discipline="corporate-communications" data-track-location="home-discipline" aria-label="View the JTI Human Rights case study">
                    <div class="parallax-container">
                      <img :src="require('@/assets/images/social/thumb_1.png')" class="social-thumb-1"
                        alt="Womens Mental Health" loading="lazy" />
                    </div>
                  </router-link>
                  <router-link to="/our-work/jti-human-rights" class="discipline-link" data-case-study="jti-human-rights"
                    data-discipline="corporate-communications" data-track-location="home-discipline" aria-label="View the JTI Human Rights case study">
                    <video class="lazy-video" disablePictureInPicture muted loop playsinline preload="none"
                      data-src="https://ignisshowreel.s3.eu-west-1.amazonaws.com/culture_weCreateSpace.mp4"
                      type="video/mp4">
                    </video>
                  </router-link>
                  <router-link to="/our-work/jti-human-rights" class="discipline-link" data-case-study="jti-human-rights"
                    data-discipline="corporate-communications" data-track-location="home-discipline" aria-label="View the JTI Human Rights case study">
                    <div class="parallax-container">
                      <img :src="require('@/assets/images/social/thumb_3.png')" class="social-thumb-3"
                        alt="International Mens Day Campaign" loading="lazy" />
                    </div>
                  </router-link>
                  <router-link to="/our-work/jti-human-rights" class="discipline-link" data-case-study="jti-human-rights"
                    data-discipline="corporate-communications" data-track-location="home-discipline" aria-label="View the JTI Human Rights case study">
                    <video class="lazy-video" disablePictureInPicture muted loop playsinline preload="none"
                      data-src="https://ignisshowreel.s3.eu-west-1.amazonaws.com/culture_video_thumb.mp4"
                      type="video/mp4">
                    </video>
                  </router-link>
                </div>
                <p class="discipline-copy">{{ discipline.copy }}</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script setup>
import { computed, ref } from 'vue';
import disciplines from '@/data/disciplines';

const props = defineProps({
  // 'experiential' | 'shopper' | 'social' | 'comms'
  name: { type: String, required: true },
  // h1 on the discipline's own page, h2 where the panels are stacked on the homepage
  headingTag: { type: String, default: 'h2' },
  // Link the heading through to the discipline's own page
  linked: { type: Boolean, default: false },
});

const discipline = computed(() => disciplines.find((d) => d.key === props.name));

const videos = ref([
  'https://ignisshowreel.s3.eu-west-1.amazonaws.com/Shopper_left_v1a.mp4',
  'https://ignisshowreel.s3.eu-west-1.amazonaws.com/peroni_tile_video.mp4',
  'https://ignisshowreel.s3.eu-west-1.amazonaws.com/Shopper_right_v1a.mp4'
]);
</script>
